/** Objects-only adapter: presentation state only; purchase uses the theme's existing form. */
class SancturaObjectCard extends HTMLElement {
  #controller;
  #default;
  #detail;
  #toggle;

  connectedCallback() {
    if (this.#controller) return;
    this.#default = this.querySelector('[data-sod-default]');
    this.#detail = this.querySelector('[data-sod-detail]');
    this.#toggle = this.querySelector('[data-sod-toggle]');
    if (!this.#default || !this.#detail || !this.#toggle) return;
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.#toggle.hidden = true;
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse' && !this.#default.contains(document.activeElement)) this.#setOpen(true);
    }, options);
    this.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) this.#setOpen(false);
    }, options);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.#setOpen(false);
    }, options);
    this.#toggle.addEventListener('click', () => {
      this.#setOpen(!this.hasAttribute('data-sod-open'));
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.hasAttribute('data-sod-open')) return;
      event.preventDefault();
      event.stopPropagation();
      this.#setOpen(false);
      this.#default.focus({ preventScroll: true });
    }, options);
    const image = this.#detail.querySelector('img');
    const failImage = () => {
      const restoreFocus = this.#detail.contains(document.activeElement) || document.activeElement === this.#toggle;
      this.#setOpen(false);
      this.#toggle.hidden = true;
      this.#controller?.abort();
      if (restoreFocus) this.#default.focus({ preventScroll: true });
    };
    image?.addEventListener('error', failImage, options);
    if (image?.complete && !image.naturalWidth) failImage();
  }

  #setOpen(open) {
    this.toggleAttribute('data-sod-open', open);
    this.#default.inert = open;
    this.#default.setAttribute('aria-hidden', String(open));
    this.#detail.inert = !open;
    this.#detail.setAttribute('aria-hidden', String(!open));
    this.#toggle.setAttribute('aria-expanded', String(open));
    this.#toggle.setAttribute('aria-label', open ? this.#toggle.dataset.defaultLabel : this.#toggle.dataset.previewLabel);
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
    if (this.#detail && this.#default && this.#toggle) this.#setOpen(false);
  }
}

if (!customElements.get('sanctura-object-card')) {
  customElements.define('sanctura-object-card', SancturaObjectCard);
}
